import React from 'react';
import { TextField } from '@mui/material';

const FormInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  type = 'text',
  select = false,
  children,
  ...props
}) => {
  return (
    <TextField
      fullWidth
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={!!error}
      helperText={error}
      type={type}
      select={select}
      variant="outlined"
      {...props}
    >
      {select && children}
    </TextField>
  );
};

export default FormInput;